/* Prootto motion: gentle scroll reveals, staggered cards and number count-ups.
   - Only animates things that start below the fold (no flash on load).
   - Removes its classes when done so hover effects keep working.
   - Respects prefers-reduced-motion. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var SINGLE = ['.lx-head', '.pt-head', '.bf__head', '.bd__bar', '.lxb', '.lxf', '.ca-spot__card', '.ca-adp__grid',
    '.ca-codes__grid', '.ca-final', '.lx-assure__list', '.bf__label', '.bf__hint', '.pt-types__note', '.pt-foot__brand'];
  var GROUPS = ['.lx-cats', '.bd__grid', '.bf__types', '.bf__sizes', '.pt-types__grid', '.pt-feat__grid', '.pt-faq__list',
    '.pt-trust__list', '.pt-brands__grid', '.product-grid', '.pf-trust'];

  var vh = window.innerHeight || 800;
  var targets = [];
  function below(el) { var r = el.getBoundingClientRect(); return r.top > vh * 0.92; }
  function skip(el) { return el.closest('.mh, .pa, header, .header, .menu-drawer, dialog'); }
  function mark(el, i) {
    if (!el || el.classList.contains('rv') || skip(el) || !below(el)) return;
    el.classList.add('rv');
    el.style.setProperty('--rv-i', Math.min(i || 0, 8));
    targets.push(el);
  }

  document.querySelectorAll(SINGLE.join(',')).forEach(function (el) { mark(el, 0); });
  document.querySelectorAll(GROUPS.join(',')).forEach(function (g) {
    var i = 0;
    Array.prototype.forEach.call(g.children, function (c) { if (c.offsetParent !== null) mark(c, i++); });
  });
  if (!targets.length) return;
  document.documentElement.classList.add('pt-motion');

  function done(el) {
    el.classList.remove('rv', 'is-in');
    el.style.removeProperty('--rv-i');
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      el.classList.add('is-in');
      var t = setTimeout(function () { done(el); }, 1400);
      el.addEventListener('transitionend', function h(ev) {
        if (ev.target !== el || ev.propertyName !== 'opacity') return;
        el.removeEventListener('transitionend', h); clearTimeout(t); done(el);
      });
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (el) { io.observe(el); });
})();

/* Count-up for stat numbers (collection header, brand directory) */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.ch__stats strong, .bd__count strong');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var el = e.target, m = el.textContent.trim().match(/^(\D*)([\d,]+)(.*)$/);
      if (!m) return;
      var end = parseInt(m[2].replace(/,/g, ''), 10), t0 = performance.now(), dur = 900;
      if (!end) return;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur), ez = 1 - Math.pow(1 - k, 3);
        el.textContent = m[1] + Math.round(end * ez).toLocaleString('en-IN') + m[3];
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { io.observe(el); });
})();

/* Prootto Assist: launcher appears after 10s on the page (or at once if already shown this session) */
(function () {
  function init() {
    var R = document.getElementById('ptc'); if (!R) return;
    var fab = R.querySelector('.ptc-fab'), P = R.querySelector('.ptc-p'), t = R.querySelector('.ptc-h strong');
    if (t) t.textContent = 'Prootto Assist';
    var lbl = fab.querySelector('span'); if (lbl) lbl.textContent = 'Prootto Assist';
    fab.setAttribute('aria-label', 'Open Prootto Assist');
    var css = document.createElement('style');
    css.textContent = '.ptc-fab{opacity:0;visibility:hidden;transform:translateX(130%);transition:transform .45s cubic-bezier(.2,.9,.3,1.2),opacity .3s,visibility .3s}' +
      '.ptc-fab.is-on{opacity:1;visibility:visible;transform:none}' +
      '.ptc-tip{position:fixed;right:18px;bottom:148px;z-index:70;max-width:260px;padding:14px 34px 14px 16px;border-radius:16px 16px 4px 16px;background:#fff;color:#0B1F3A;box-shadow:0 18px 40px rgba(11,31,58,.22);font-size:.88rem;line-height:1.4;cursor:pointer;animation:ptcTip .4s ease}' +
      '.ptc-tip b{display:block;margin-bottom:2px}.ptc-tip span{color:#0057B8;font-weight:600}' +
      '.ptc-tip button{position:absolute;top:6px;right:8px;border:0;background:none;font-size:1.1rem;color:#6B7B8F;cursor:pointer}' +
      '@keyframes ptcTip{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}' +
      '@media (max-width:749px){.ptc-fab{padding:12px!important;border-radius:50%!important}.ptc-fab span{display:none}.ptc-tip{right:12px;bottom:136px;max-width:230px}}';
    document.head.appendChild(css);
    var seen = false; try { seen = sessionStorage.getItem('ptcSeen') === '1'; } catch (e) {}
    function tip() {
      var d = document.createElement('div'); d.className = 'ptc-tip'; d.setAttribute('role', 'status');
      d.innerHTML = '<b>Unable to find the perfect blade?</b>Prootto Assist can help – <span>find yours in 4 taps →</span><button type="button" aria-label="Dismiss">×</button>';
      d.onclick = function (e) { d.remove(); if (e.target.tagName !== 'BUTTON') fab.click(); };
      document.body.appendChild(d);
      setTimeout(function () { if (d.parentNode) d.remove(); }, 12000);
      fab.addEventListener('click', function () { if (d.parentNode) d.remove(); });
    }
    function show(withTip) { fab.classList.add('is-on'); try { sessionStorage.setItem('ptcSeen', '1'); } catch (e) {} if (withTip && P.hidden) tip(); }
    if (seen) show(false); else setTimeout(function () { show(true); }, 10000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
